import React, { Component } from 'react';
import { withRouter, Switch, Redirect } from 'react-router';

import { HotmartRum } from '@hot-observability-js/react';
import NewClubMigrationAlert from 'components/newClubMigrationAlert/newClubMigrationAlert';
import { ProductFruits } from 'components/productFruits';
import { ROUTES } from 'configs/routes/constants';
import ProfileBasedRedirect from 'configs/routes/ProfileBasedRedirect';
import Settings from 'configs/Settings';
import { isRenderInIframe } from 'helpers/Location';
import { withAddSurvicateUserInfo } from 'hoc/withAddSurvicateUserInfo';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import {
  COMMON_ROUTES,
  MODERATOR_ROUTES,
  PRIVATE_ROUTES
} from 'modules/app/routes';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { AuthService } from 'modules/auth';
import { Sidebar } from 'modules/navigation';
import { filterOnlineEventRoutes } from 'modules/onlineEvent/helpers';
import { TosService } from 'modules/tos';
import { UiService } from 'modules/ui';
import { UserService } from 'modules/user';
import PropTypes from 'prop-types';

import { renderRoutes } from './helper';

import packageJson from '../../../package.json';

import '@hotmart/cosmos/dist/content';
import '@hotmart/cosmos/dist/content-menu';

import './Logged.scss';

@withRouter
@inject('MembershipStore', 'UserStore')
@withAddSurvicateUserInfo
class Logged extends Component {
  static propTypes = {
    MembershipStore: MobxPropTypes.objectOrObservableObject,
    UserStore: MobxPropTypes.objectOrObservableObject,
    location: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.setup();
  }

  componentDidUpdate(prevProps) {
    this.setup();

    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.sendNavigateEvent(prevProps.location, this.props.location);
    }
  }

  async componentDidMount() {
    const {
      location,
      MembershipStore: { loaded }
    } = this.props;

    if (loaded) {
      this.renderLegalBlock();
      this.sendNavigateEvent(location, location);
    }
  }

  sendNavigateEvent(prevLocation, curLocation) {
    try {
      DatahubService.sendPageViewEvent(prevLocation, curLocation);
      // eslint-disable-next-line no-empty
    } catch {}
  }

  setup() {
    const { onlineEvent } = this.props.MembershipStore;
    let routesByProfile = [];

    if (AuthService.isModerator()) {
      routesByProfile = MODERATOR_ROUTES;
    } else {
      const routes = [...COMMON_ROUTES, ...PRIVATE_ROUTES];

      routesByProfile = onlineEvent ? filterOnlineEventRoutes(routes) : routes;
    }

    this.routes = renderRoutes(routesByProfile);
  }

  async renderLegalBlock() {
    await AuthService.validateToken();

    if (this.props.UserStore.hasInvalidToken) {
      return;
    }

    const { shortLocale } = this.props.UserStore;
    const resp = await TosService.fetchUnleashTosToggles();

    try {
      const params = {
        bearerAuth: `Bearer ${AuthService.token}`,
        language: shortLocale,
        acceptCallback: async () => {
          await UserService.syncUserData();
          window.location.reload();
        },
        isProduction: Settings.isProduction(),
        tosProject: 'HOTMART',
        tosType: 'GDPR',
        appName: packageJson.name
      };

      if (resp && resp.canUseTOSApiV2) {
        params.tosType = null;
        params.apiVersion = 'v2';
      }

      window.blockUser && window.blockUser(params);
    } catch (error) {
      HotmartRum.captureException(error);
    }
  }

  renderRedirectFromOldRoutes() {
    const {
      location: { pathname }
    } = this.props;

    const oldToNewRoutes = {
      '/broadcastManager': ROUTES.BROADCAST.LIST,
      '/configManager': ROUTES.CONFIG,
      '/membershipClassManager': ROUTES.CLASS.LIST,
      '/salesManager': ROUTES.SALES,
      '/userManager': ROUTES.USER.LIST,
      '/community': ROUTES.COMMUNITY.LIST
    };
    const to = oldToNewRoutes[pathname];

    return to && <Redirect to={to} />;
  }

  onLibraryError = (e, successCalback) => {
    UiService.handleInvalidToken(e, successCalback, { hideAlert: true });
  };

  render() {
    const {
      location,
      MembershipStore: { loaded }
    } = this.props;

    return (
      <hot-structure>
        <Sidebar location={location} />

        {isRenderInIframe() && <div className="header-iframe" />}

        <hot-content id="content" class="content" slot="content">
          <NewClubMigrationAlert />
          <Switch>
            {this.routes}
            {this.renderRedirectFromOldRoutes()}
            {loaded && <ProfileBasedRedirect location={location} />}
          </Switch>

          <ProductFruits />
        </hot-content>
      </hot-structure>
    );
  }
}

export default Logged;
